<template>

  <div class="d-center-content fill-height d-article" :class="{'mr-7': $vuetify.breakpoint.smAndDown}">

    <!-- Reiter Pauschalreisen / Mietbus auf der Reisebedingungen-Seite (gleiche Einhänger-Optik wie d-skew-mother) -->
    <div class="d-rb-tabs" v-if="isReisebedingungen">
      <div class="d-skew-mother d-rb-tab" :class="{ 'd-rb-tab--active': tab === 0 }" @click="tab = 0">
        <div class="d-skew-left px-10">Pauschalreisen</div>
        <div class="d-skew-center"></div>
        <div class="d-skew-right"></div>
        <div class="d-skew-abdecker"></div>
        <div class="d-skew-abdecker-white"></div>
      </div>
      <div class="d-rb-tab-right" :class="{ 'd-rb-tab-right--active': tab === 1 }" @click="tab = 1" v-if="mietbusArticle">
        <div class="d-skew-left d-rb-right-body px-10">Mietbus</div>
      </div>
    </div>
    <div class="d-skew-mother" v-else-if="headline != 'Newsletter'">
      <div class="d-skew-left px-10" v-if="headline">
        <span v-if="headline == 'Komm-ins-Team'">{{article.title}}!</span>
        <span v-else>{{headline}}</span>
      </div>
      <div class="d-skew-center"></div>
      <div class="d-skew-right"></div>
      <div class="d-skew-abdecker "></div>
      <div class="d-skew-abdecker-white "></div>
    </div>
    <div class="d-content-content">

        <!-- <pre> {{ article }} </pre> -->
        <v-container class="us-transition py-0 pl-0 pr-4" style="overflow-y:auto;">
            <template v-if="isReisebedingungen">
              <div v-show="tab === 0" v-html="pauschalArticle ? pauschalArticle.html : ''"></div>
              <div v-show="tab === 1" v-html="mietbusArticle ? mietbusArticle.html : ''"></div>
            </template>
            <div v-else v-html="article.html"></div>
        </v-container>

    </div>

    <FormJob :job="headline" v-if="headline == 'Jobs Fahrer' ||  headline == 'Jobs Office' || headline == 'Komm ins Team' || headline == 'Komm ins Team Busfahrer'"></FormJob>


  </div>
</template>

<script>
import { mapState } from "vuex"
import FormJob from "@/components/Forms/Job"
export default {
    components: {
        FormJob
    },
    computed: {
        ...mapState(["ContentStore"]),
        isReisebedingungen() {
            const a = this.article || {}
            return ["Reisebedingungen", "AGB_Mietbus"].includes(a.alias) || ["Reisebedingungen", "AGB_Mietbus"].includes(a.title)
        },
        pauschalArticle() {
            return this.ContentStore.find(item => item.alias === "Reisebedingungen" || item.title === "Reisebedingungen")
        },
        mietbusArticle() {
            return this.ContentStore.find(item => item.alias === "AGB_Mietbus" || item.title === "AGB_Mietbus")
        }
    },
    data() {
        return {
            headline:"Willkommen",
            tab: 0,
            article: {
                id_web_content: null,
                title: null,
                alias: null,
                html: null
            }
        }
    },
    watch: {
        $route(to, from) {
            this.args = core.getPathArgs(["id"])
            this.loadArticle()
        }
    },
    mounted() {
        this.args = core.getPathArgs(["id"])
        if (this.args.id === undefined && this.ContentStore.find(item => item.title == "Willkommen") !== undefined) {
            this.args.id = this.ContentStore.find(item => item.title == "Willkommen").id_web_content
        }
        if (this.ContentStore.find(item => item.id_web_content == this.args.id || item.alias == this.args.id) === undefined) {
            this.article = {
                id_web_content: 0,
                title: "",
                alias: "",
                html: "Der Inhalt dieser Seite wurde leider nicht gefunden. Klicken Sie <a href=\"#/\">hier</a>, um zurück zur Startseite zu gelangen."
            }
        } else {
            this.loadArticle()
        }
        core.on("content-finished", this.loadArticle)
    },
    methods: {
        loadArticle() {


            if (this.args.id === undefined) {
                this.args.id = this.ContentStore.find(item => item.title == "Willkommen").id_web_content
            }


            this.article = this.ContentStore.find(item => item.id_web_content == this.args.id || item.alias == this.args.id)
            this.headline = this.article.title == 'Reisebuero' ? 'Reisebüro' : this.article.title

            // Auf der Reisebedingungen-Seite den passenden Reiter vorwählen
            const a = this.article || {}
            this.tab = (a.alias === "AGB_Mietbus" || a.title === "AGB_Mietbus") ? 1 : 0

        }
    }
}
</script>

<style lang="scss">
    /* Reiter Pauschalreisen / Mietbus auf der Reisebedingungen-Seite */
    .d-rb-tabs {
        display: flex;
        align-items: flex-start;
        margin-bottom: 18px;
    }
    /* jede Lasche erbt d-skew-mother (display:flex, height:50px, margin-left:-32px) */
    .d-rb-tab {
        width: auto;
        cursor: pointer;
    }
    /* aktiver linker Einhänger: Döring-Rot statt Beige */
    .d-rb-tab--active .d-skew-left,
    .d-rb-tab--active .d-skew-center,
    .d-rb-tab--active .d-skew-right {
        background: var(--v-primary-base);
    }
    /* rechter Reiter: schräge linke Kante, ohne Abdecker (Parallelogramm) */
    .d-rb-tab-right {
        cursor: pointer;
        margin-left: -16px;
        filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.30));
    }
    .d-rb-tab-right .d-rb-right-body {
        box-shadow: none;
        /* Versatz = tan(30deg) * 50px Hoehe ~ 29px, damit parallel zur d-skew-right (skew 30deg) */
        clip-path: polygon(0 0, calc(100% - 29px) 0, 100% 100%, 29px 100%);
    }
    .d-rb-tab-right--active .d-rb-right-body {
        background: var(--v-primary-base);
    }

    .main-content-article {
        height: 100%;
        overflow: auto;
        padding: 0px 10px 20px 0px;
    }
    .us-scroll-versatz{
        padding-right:20px;
    }
    #us-all-Journey-cart1 { height:calc(100% - 0px) ; overflow: hidden; }
    .us-grid-two-top, .us-grid-two-bottom {height:10px;}
    .us-pic-container-category-right{
        width:100%;
        height:calc(100% - 20px) ;
        // background-image:url('../assets/image/kpic1.jpg');
        background-repeat: no-repeat; background-position: 25% 50%; background-size: cover;
        position:relative;
    }


    .d-article img {
        max-width:100% !important;
        height:auto !important;
        padding-right:20px !important;
    }
    .d-article a {
        text-decoration:none;
    }

    .imageTextResponsive {
        display: flex;
        gap: 12px;
    }
    
    .imgBewerbung {
        display: flex;
        justify-content: center;
        align-content: center;
    }

    @media (min-width: 1264px) {
        .imageTextResponsive {
            flex-direction: row;
        }
        .orderIMG {
            order: 2 !important;
        }
        .orderText {
            order: 1 !important;
        }
        .bewerbungText1 {
            display: block;
        }
        .bewerbungText2 {
            display: none;
        }
    }
    @media (max-width: 1264px) {
        .imageTextResponsive {
            flex-direction: column;
        }
        .orderIMG {
            order: 1 !important;
        }
        .orderText {
            order: 2 !important;
        }
        .bewerbungText1 {
            display: none;
        }
        .bewerbungText2 {
            display: block;
        }
    }
</style>